
import type { Result } from '@empathybroker/tsclient-play/dist/models/search/result'
import type { PropType } from 'vue'
import type { Pagination } from '../models/components/pagination'
import { defineComponent, ref } from 'vue'

import { ListAnimationMixin } from '../mixins/list-animation.mixin'

import PaginationBar from './crud/pagination-bar.component.vue'
import { UiProgressLinear } from './keen-ui'
import ResultCard from './result-card.component.vue'

export default defineComponent({
  name: 'ResultsGrid',
  components: {
    UiProgressLinear,
    ResultCard,
    PaginationBar,
  },
  mixins: [ListAnimationMixin],
  props: {
    results: {
      type: Array as PropType<Array<Result>>,
      default: () => [],
    },
    resultsHoverDisabled: {
      type: Boolean,
    },
    pagination: Object as PropType<Pagination>,
    total: {
      type: Number,
      default: () => 0,
    },
    partial: {
      type: Number,
      default: () => 0,
    },
    lastPageDisabled: Boolean,
    loading: Boolean,
    selectedResultIds: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    messages: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const resultsContainer = ref()

    const scrollTo = (resultId: string): void => {
      const selectedResultCard = resultsContainer.value.$children.find(
        resultCard => resultCard.$props.result.id === resultId,
      )

      resultsContainer.value?.$el.scrollTo({
        top: selectedResultCard?.$el.offsetTop,
        behavior: 'smooth',
      })
    }

    return {
      resultsContainer,
      scrollTo,
    }
  },
})
